import { useMutation } from "react-query";
import { updateCarrier } from "../../../../actions/CarrierAgreementMgmt/Carrier";

const useEditCarrier = () => {
  //Add new carrier function
  return useMutation(updateCarrier);
};
export default useEditCarrier;
